export const getters = {
    getUsers(state: any): object {
        return state.users;
    },
    getLogins(state: any): object {
        return state.logins;
    },
    getSelectedUser(state: any): object {
        return state.selectedUser;
    },
    getSelectedModel(state: any): object {
        return state.selectedModel;
    },
    getSelectedScenario(state: any): object {
        return state.selectedScenario;
    },
    getModels(state: any): object {
        return state.models;
    },
    getScenarioStatus(state: any): object {
        return state.scenarioStatus;
    },
    getLoginEditing(state: any): object {
        return state.loginEditing;
    },
    getGroups(state: any): object {
        return state.groups;
    },
    getSelectedGroup(state: any): object {
        return state.selectedGroup;
    },
    getGroupUsers(state: any): object {
        return state.groupUsers;
    },
    getModelGroups(state: any): object {
        return state.modelGroups;
    },
    getModelRoles(state: any): object {
        return state.modelRoles;
    },
    getGlobalRoles(state: any): object {
        return state.globalRoles;
    },
    getSelectedRole(state: any): object {
        return state.selectedRole;
    },
    getRoleGroups(state: any): object {
        return state.roleGroups;
    },
    getIsAddingGroup(state: any): boolean {
        return state.isAddingGroup;
    },
    getIsAddingLogin(state: any): boolean {
        return state.isAddingLogin;
    },
    getUserAccess(state: any): any {
        return state.userAccess;
    },
    getUsageStats(state: any): any {
        return state.usageStats;
    },
    getUsageUsers(state: any): any[] {
        return state.usageUsers;
    },
    getUsageModels(state: any): any[] {
        return state.usageModels;
    },
    getAdminDialogOpen(state: any): boolean {
        return state.selectedGroup != null || state.isAddingGroup ||
               state.selectedModel != null ||
               state.selectedRole != null ||
               state.isAddingLogin;
    },
};
